import React, { useContext, useEffect, useState } from 'react';

import FilterCtx from '../../../../context/filterContext/filterCtx';

import { ITypePickerFilter } from '../../types/ITypePickerFilter';

import Icon from '../../icon/icon';

import '../filters.scss';

const TypePickerFilter: React.FC<ITypePickerFilter> = ({ className }) => {
  const [typePickerBoard, setTypePickerBoard] = useState<boolean>(false);
  const [typePickerDocument, setTypePickerDocument] = useState<boolean>(false);

  const filterCtx: any = useContext(FilterCtx);

  useEffect(() => {
    setTypePickerBoard(filterCtx.typePickerBoard);
    if (filterCtx.typePickerBoard) {
      setTypePickerDocument(false);
    }
  }, [filterCtx.typePickerBoard]);

  useEffect(() => {
    setTypePickerDocument(filterCtx.typePickerDocument);
    if (filterCtx.typePickerDocument) {
      setTypePickerBoard(false);
    }
  }, [filterCtx.typePickerDocument]);

  return (
    <div className={`type-picker-container ${className ? className : ''}`}>
      <Icon name='fal fa-tachometer-alt-average' className={`type-picker-icon pointer ${typePickerBoard ? 'active' : ''}`}
            onClick={() => {
              filterCtx.setTypePickerBoard(!filterCtx.typePickerBoard);
              filterCtx.setTypePickerDocument(false);
            }} />
      <Icon name='fal fa-file-chart-line' className={`type-picker-icon pointer ${typePickerDocument ? 'active' : ''}`}
            onClick={() => {
              filterCtx.setTypePickerDocument(!filterCtx.typePickerDocument);
              filterCtx.setTypePickerBoard(false);
            }} />
      <span className='devider' />
    </div>
  );
};

export default TypePickerFilter;